import { trackGladlySidekickClick } from 'src/analytics/events/trackGladlySidekickClick';
import { GladlyService } from '@/account/cx/';

// Track path and component that was used to invoke this action
export const showLiveChat = (path: string, initiator: string) => {
  GladlyService.show();
  trackGladlySidekickClick({ path, initiator });
};
